var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgTickets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 135",
    enableBackground: "new 0 0 130 135",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#912C22",
    cx: 66.4,
    cy: 66.6,
    r: 54.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M66.4,124C34.8,124,9,98.2,9,66.6S34.8,9.5,66.4,9.5s57.4,25.8,57.4,57.4S98.1,124,66.4,124z M66.4,15.6 c-28.3,0-51.3,22.7-51.3,51s23,51.3,51.3,51.3s51.3-23,51.3-51.3S94.7,15.6,66.4,15.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M97.6,55.9l-5.1-5.1c-1.5,1.5-3.3,2.3-5.5,2.3c-2.2,0-4-0.8-5.5-2.3c-1.5-1.5-2.3-3.3-2.3-5.5 c0-2.2,0.8-4,2.3-5.5l-5.1-5.1c-1-1-2.2-1.5-3.7-1.5c-1.4,0-2.7,0.5-3.7,1.5L32.1,71.4c-1,1-1.5,2.2-1.5,3.7c0,1.4,0.5,2.7,1.5,3.7 l5.1,5.1c1.5-1.5,3.3-2.3,5.5-2.3c2.2,0,4,0.8,5.5,2.3c1.5,1.5,2.3,3.3,2.3,5.5c0,2.2-0.8,4-2.3,5.5l5.1,5.1c1,1,2.2,1.5,3.7,1.5 c1.4,0,2.7-0.5,3.7-1.5l36.8-36.8c1-1,1.5-2.2,1.5-3.7C99.1,58.1,98.6,56.9,97.6,55.9L97.6,55.9z M86.6,64L61.5,89.1 c-0.5,0.5-1.1,0.7-1.8,0.7c-0.7,0-1.3-0.3-1.8-0.7L43.2,74.4c-0.5-0.5-0.8-1.1-0.8-1.8c0-0.7,0.3-1.3,0.8-1.8l25.1-25.1 c0.5-0.5,1.1-0.7,1.8-0.7c0.7,0,1.3,0.3,1.8,0.7l14.7,14.7c0.5,0.5,0.8,1.1,0.8,1.8C87.4,62.9,87.1,63.5,86.6,64L86.6,64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M70.1,49.4l12.8,12.8L59.7,85.4L46.8,72.6L70.1,49.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgTickets);
export default __webpack_public_path__ + "static/media/svg_tickets.0738c7332c2937a36001ac54a0ed9fac.svg";
export { ForwardRef as ReactComponent };